module.exports = __webpack_public_path__ + "header-bg.ed509bb3fb53039b4680.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header-bg.jpg
// module id = 172
// module chunks = 1